function buildConfig() {
  if (!process.env.__APP_ENV__) {
    throw new Error("Environment variable __APP_ENV__ is not set")
  }

  if (!process.env.API_ENDPOINT) {
    throw new Error("Environment variable API_ENDPOINT is not set")
  }

  const isDevelopment = process.env.ENV_NAME === "development"
  const isDemo = process.env.ENV_NAME === "demo"
  const isProduction = process.env.ENV_NAME === "production"

  const mixpanelToken = isProduction
    ? "28e98c191a1d982c418afe20e0399a33"
    : "25ea2dca6b06efab8567eb35e704511a"

  const getLangsmithProjectId = () => {
    if (isProduction) {
      return "fc53a228-42db-413c-a9a6-7754ebabf1c7"
    }
    if (isDemo) {
      return "e36a6414-2060-4d9c-abfc-21bbda000033"
    }
    return "55d2fee0-35bd-49c4-9e65-64498a58a83a"
  }

  const langsmithProjectId = getLangsmithProjectId()

  const config = {
    isDevelopment,
    isDemo,
    isProduction,
    apiEndpoint: process.env.API_ENDPOINT!,
    sentryDsn: process.env.SENTRY_FRONTEND_DSN,
    releaseVersion: process.env.RELEASE_VERSION,
    mixpanelToken,
    facebookEmbedded: {
      appId: process.env.VITE_WHATSAPP_EMBEDDED_APP_ID,
      configId: process.env.VITE_WHATSAPP_EMBEDDED_CONFIG_ID,
    },
    langsmith: {
      projectId: langsmithProjectId,
    },
    instagramLoginUrl: process.env.VITE_INSTAGRAM_LOGIN_URL,
  }

  return config
}

let config: ReturnType<typeof buildConfig> | null = null

if (!config) {
  config = buildConfig()
}

export default config!
